import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RoadHorizon } from "@phosphor-icons/react";
import { fetchTollTagForTruck } from "@/lib/api";

export const TruckTollBadge = ({ truckId }) => {
  const [tag, setTag] = useState(null);

  useEffect(() => {
    fetchTollTagForTruck(truckId).then(setTag).catch(() => setTag(null));
  }, [truckId]);

  return (
    <Link
      to="/telepeages"
      className={`px-2 py-1 text-[10px] font-bold uppercase tracking-widest border inline-flex items-center gap-1 transition-colors ${
        tag ? "bg-amber-50 border-[var(--ny-gold)] text-[var(--ny-gold-deep)] hover:bg-amber-100" : "bg-zinc-50 border-dashed border-zinc-300 text-zinc-400 hover:text-zinc-600"
      }`}
      data-testid="truck-toll-badge"
    >
      <RoadHorizon size={10} weight="bold" />
      {tag ? `Télépéage N°${tag.number}` : "Aucun télépéage"}
    </Link>
  );
};
